module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-popover', {
    staticClass: "db-soft-select",
    attrs: {
      "popper-class": 'dept-select-popover' + _vm.popper_class_unique,
      "disabled": _vm.disabled,
      "placement": "bottom",
      "width": _vm.popper_width,
      "trigger": "click"
    },
    model: {
      value: (_vm.search_tree_visible),
      callback: function($$v) {
        _vm.search_tree_visible = $$v
      },
      expression: "search_tree_visible"
    }
  }, [_c('db-soft-tree', {
    ref: "search_tree",
    attrs: {
      "req_param": _vm.req_param,
      "support_soft_type": _vm.support_soft_type,
      "check_role": _vm.check_role,
      "model_type": _vm.model_type,
      "is_all": _vm.is_all,
      "target_value": _vm.target_value,
      "value_field": _vm.value_field,
      "only_parent": _vm.only_parent,
      "auto_select_first": false,
      "tree_style": {
        width: (_vm.popper_width - 5) + 'px',
        border: 'none',
        background: '#FCFCFC'
      },
      "show_header": false,
      "content_height": "300px"
    },
    on: {
      "node_click": _vm.node_click,
      "node_checked": _vm.node_checked
    }
  }), _vm._v(" "), _c('ni-input', {
    staticClass: "node-text-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "reference",
      "placeholder": "请选择数据库",
      "size": "mini",
      "readonly": "",
      "clearable": "",
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.input_focus
    },
    slot: "reference",
    model: {
      value: (_vm.input_text),
      callback: function($$v) {
        _vm.input_text = $$v
      },
      expression: "input_text"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-fa5ad32e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/db-soft-select/db-soft-select.vue
// module id = Jt5Q
// module chunks = 81